import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/data/site";

export const useSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      scrollToId(id);
    }
  };
};
